import { Typography, Box, Footer } from 'components';
import useTitle from 'hooks/useTitle';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Content, Divider, IconCircle, StyleContainer, StyledHeader, TimeBox, TimeLabel, TimeMain, TimeSub } from './style';
import LogoSPIcon from 'components/Icon/LogoSPIcon';

const TIME_REFRESH_PAGE = 6 * 60 * 60 * 1000; // 6h

function Maintenance({ returnTo = '/' }) {
  const { t } = useTranslation();
  useTitle(t('common:pageTitle:maintenance'));

  useEffect(() => {
    let intervalId;

    const check = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL.replace(/\/api$/, '')}/maintenance`, { cache: 'no-store' });
        const data = await res.json().catch(() => ({}));

        if (data?.status === 'operational') {
          window.location.replace(returnTo);
        }
      } catch (_) {
        // ignore
      }
    };

    check();
    intervalId = setInterval(check, TIME_REFRESH_PAGE);

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [returnTo]);
  const maintenanceDate = '2025年12月29日';
  const maintenanceTime = '00:00 - 23:59 (JST)';

  return (
    <StyleContainer>
      <StyledHeader>
        <LogoSPIcon />
      </StyledHeader>
      <Content>
        <Card>
          <Box display="flex" justifyContent="center" mb={16}>
            <IconCircle aria-hidden>!</IconCircle>
          </Box>
          <Typography variant="h3" align="center">
            { t('common:maintenance:title') }
          </Typography>
          <Divider />
          <Box mt={16}>
            <Typography variant="description" align="center">
              { t('common:maintenance:desc') }
            </Typography>
          </Box>
          <Box mt={24}>
            <TimeBox>
              <TimeLabel>
                <Typography variant="caption">
                  { t('common:maintenance:timeLabel') }
                </Typography>
              </TimeLabel>

              <TimeMain>
                <Typography variant="h4">{maintenanceDate}</Typography>
              </TimeMain>

              <TimeSub>
                <Typography variant="description">{maintenanceTime}</Typography>
              </TimeSub>
            </TimeBox>
          </Box>
          <Box mt={24}>
            <Typography variant="description" align="center">
              { t('common:maintenance:note') }
            </Typography>
          </Box>
        </Card>
      </Content>
      <Footer />
    </StyleContainer>
  );
}

export default Maintenance;
